// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Colours_visuallyHidden__BHLLf","colourContainer":"Colours_colourContainer__XPjI_"};